import React from 'react';
import { Button, message } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { TEMPLATE_FORM_CONSTANTS } from '../constants';
import {
  FormSection,
  FormLabel,
  AttachmentDropZone,
  AttachmentDropZoneText,
  AttachmentList,
  AttachmentItem,
  AttachmentItemName,
  HelperText,
} from '../styles';

interface FormAttachmentsProps {
  attachments: any[];
  onAttachmentsChange: (attachments: any[]) => void;
}

const FormAttachments: React.FC<FormAttachmentsProps> = ({ attachments, onAttachmentsChange }) => {
  const handleAttachmentClick = () => {
    message.info(TEMPLATE_FORM_CONSTANTS.MESSAGES.FILE_UPLOAD_DESC);
  };

  const handleRemoveAttachment = (index: number) => {
    const newAttachments = attachments.filter((_, i) => i !== index);
    onAttachmentsChange(newAttachments);
  };

  return (
    <FormSection>
      <FormLabel>{TEMPLATE_FORM_CONSTANTS.LABELS.ATTACHMENTS}</FormLabel>
      <HelperText>{TEMPLATE_FORM_CONSTANTS.MESSAGES.ATTACHMENTS_DESC}</HelperText>

      <AttachmentDropZone onClick={handleAttachmentClick} style={{ marginTop: '12px' }}>
        <AttachmentDropZoneText>📎 {TEMPLATE_FORM_CONSTANTS.MESSAGES.DRAG_FILES_HERE}</AttachmentDropZoneText>
        <AttachmentDropZoneText style={{ fontSize: '12px', marginTop: '8px', opacity: 0.7 }}>
          {TEMPLATE_FORM_CONSTANTS.MESSAGES.CURRENT_ATTACHMENTS.replace(
            '{count}',
            attachments.length.toString()
          )}
        </AttachmentDropZoneText>
      </AttachmentDropZone>

      {attachments.length > 0 && (
        <AttachmentList>
          <FormLabel style={{ marginBottom: '8px' }}>
            {TEMPLATE_FORM_CONSTANTS.MESSAGES.CURRENT_ATTACHMENTS.replace(
              '{count}',
              attachments.length.toString()
            )}
          </FormLabel>
          {attachments.map((attachment, index) => (
            <AttachmentItem key={index}>
              <AttachmentItemName>{attachment.name || `Attachment ${index + 1}`}</AttachmentItemName>
              <Button
                type="text"
                danger
                size="small"
                icon={<DeleteOutlined />}
                onClick={() => handleRemoveAttachment(index)}
              >
                {TEMPLATE_FORM_CONSTANTS.BUTTONS.REMOVE}
              </Button>
            </AttachmentItem>
          ))}
        </AttachmentList>
      )}
    </FormSection>
  );
};

export default FormAttachments;
